



























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateCarbonfactor from "./createcarbonfactor.vue";
import EditCarbonfactor from "./editcarbonfactor.vue";
import "@/assets/css/table.css";
import checkAuth from "@/lib/Common/checkauth";

class PageCarbonfactorRequest extends PageRequest {
    keyword: string;
}

@Component({
    components: { CreateCarbonfactor, EditCarbonfactor },
})
export default class Carbonfactor extends AbpBase {
    //检测按钮权限
    checkButtonAuth(tag: string) {
        return checkAuth.CheckButton(tag);
    }
    edit() {
        this.editModalShow = true;
    }
    //filters
    pagerequest: PageCarbonfactorRequest = new PageCarbonfactorRequest();

    createModalShow: boolean = false;
    editModalShow: boolean = false;
    get list() {
        return this.$store.state.carbonfactor.list;
    }
    get loading() {
        return this.$store.state.carbonfactor.loading;
    }
    create() {
        this.createModalShow = true;
    }
    pageChange(page: number) {
        this.$store.commit("carbonfactor/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("carbonfactor/setPageSize", pagesize);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "carbonfactor/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.carbonfactor.pageSize;
    }
    get totalCount() {
        return this.$store.state.carbonfactor.totalCount;
    }
    get currentPage() {
        return this.$store.state.carbonfactor.currentPage;
    }
    columns = [
        {
            title: this.L("ResourceType"),
            key: "resourceId",
            width: 130,
            render: (h: any, params: any) => {
                let id = params.row.resourceId;
                let ite = JSON.parse(localStorage.getItem("itemdetail"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: info.length == 0 ? this.L("Unknown") : info[0].name,
                        },
                    },
                    info.length == 0 ? this.L("Unknown") : info[0].name
                );
            },
        },
        {
            title: this.L("Carbonfactor"),
            key: "factor",
            width: 130,
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 150,
            render: (h: any, params: any) => {
                let del = this.checkButtonAuth('cabonfactorDel');
                let edit = this.checkButtonAuth('cabonfactorEdit');
                return h("div", [
                    edit ? h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: () => {
                                    this.$store.commit("carbonfactor/edit", params.row);
                                    this.edit();
                                },
                            },
                        },
                        this.L("Edit")
                    ) : '',
                    del ? h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "carbonfactor/delete",
                                                data: params.row,
                                            });
                                            await this.getpage();
                                        },
                                    });
                                },
                            },
                        },
                        this.L("Delete")
                    ) : '',
                ]);
            },
        },
    ];
    async created() {
        this.getpage();
    }
}
